/* eslint-disable react/prop-types */
import React from 'react'
import { useSvg } from 'irmlib/hooks'

/**
 * @function
 * @description Report
 * @param {object} props props.
 * @param {string} props.fill Fill color for the icon. By default, it picks up the color of the nearest parent.
 * @param {number} props.scale Scale for the size of the icon. The default is 1.
 * @returns {object} svg of the icon
 */
export default props => {
  const viewBoxWidth = 24
  const viewBoxHeight = 24
  const [, width, height] = useSvg(props, viewBoxWidth, viewBoxHeight)
  return (
    <svg width={width} height={height} viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`} version='1.1' xmlns='http://www.w3.org/2000/svg'>
      <g id="MDI_chart-box-outline" data-name="MDI / chart-box-outline" opacity="0.6">
        <g id="Boundary" stroke="rgba(0,0,0,0)" strokeWidth="1" opacity="0">
          <rect width="24" height="24" stroke="none"/>
          <rect x="0.5" y="0.5" width="23" height="23" fill="none"/>
        </g>
        <path id="Path_chart-box-outline" data-name="Path / chart-box-outline" d="M9,17H7V10H9v7m4,0H11V7h2V17m4,0H15V13h2v4m2.5,2.1H4.5V5h15V19.1M19.5,3H4.5a2.006,2.006,0,0,0-2,2V19a2.006,2.006,0,0,0,2,2h15a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19.5,3Z" transform="translate(0.5)"/>
      </g>
    </svg>
  )
}
